import Autolinker, { AutolinkerConfig, Match, UrlMatch } from 'autolinker';
import { LinkPreview } from '@app/core/async-services/http/versioned/interfaces';

export const HE_DEFAULT_LINK_OPTIONS: AutolinkerConfig = {
  phone: false,
  stripPrefix: false,
};

export const addHyperlinksToText = (
  text: string,
  options: { linkColor?: 'primary' | 'secondary' },
): string =>
  Autolinker.link(text, {
    ...HE_DEFAULT_LINK_OPTIONS,
    className: (options && options.linkColor) || 'primary',
  });

export const getUrlsFromText = (text: string): string[] =>
  Autolinker.parse(text, HE_DEFAULT_LINK_OPTIONS)
    .filter(isUrlMatch)
    .map((match) => match.getUrl());

function isUrlMatch(match: Match): match is UrlMatch {
  return match.getType() === 'url';
}

export function showLinkPreview(linkPreview: LinkPreview): boolean {
  const hasTitle = !!linkPreview.title;
  const hasDescription = !!linkPreview.description;
  return hasTitle && hasDescription;
}
